import { render, staticRenderFns } from "./item-cost.vue?vue&type=template&id=24b415df&"
import script from "./item-cost.vue?vue&type=script&lang=js&"
export * from "./item-cost.vue?vue&type=script&lang=js&"
import style0 from "./item-cost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports